<template>
  <div class="locked-page">
    <div class="locked-content">
      <div class="icon">
        <i class="el-icon-lock"></i>
      </div>
      <h1>尾款逾期系统锁定</h1>
      <p>请联系管理员处理</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemLocked'
}
</script>

<style scoped>
.locked-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e9eef6;
}

.locked-content {
  text-align: center;
  padding: 60px 80px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.icon {
  margin-bottom: 30px;
}

.icon i {
  font-size: 80px;
  color: #f56c6c;
}

h1 {
  font-size: 28px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 600;
}

p {
  font-size: 16px;
  color: #909399;
  margin: 0;
}
</style>





















